<template>
  <div class="d-flex m-container">
    <div class="form-wrapper">
        <slot name="maintenance"></slot>
        <div class="layout-header mb-5 text-center">
          <img src="@/assets/images/wtiogomark_ra.png"
              alt="logo"
              class="img-fluid"
              style="max-width:200px;margin-bottom:25px;"
          >
          <slot name="heading"></slot>
          <!-- <div class="header-text">
            <h5>Bloomキャリア登録　企業管理画面</h5>
          </div> -->
        </div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormLayout',
};
</script>

<style scoped>

h5 {
  color: #617776;
  font-weight: bold;
}
.text-center {
  text-align: center;
}
.m-container{
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background: #fff;
}
.form-wrapper {
  max-width: 500px;
  width:100%;
  margin:auto;
  padding: 10px;
  background-color: #fff;
}
</style>
